import { render } from "./AppTopbar.vue?vue&type=template&id=536afa88&scoped=true"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=536afa88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536afa88"]])

export default __exports__